import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Interactive map of MichelChef locations (Leaflet + OpenStreetMap, no API key).
export default function MapSedi({ locations }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !ref.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false }).setView([44.7, 11.5], 7);
    mapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
      maxZoom: 18,
    }).addTo(map);

    const pin = (label) =>
      L.divIcon({
        className: "",
        html: `<div style="position:relative;transform:translate(-50%,-100%)">
          <div style="width:34px;height:34px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:#17784A;border:3px solid #fff;box-shadow:0 4px 10px rgba(0,0,0,.3)"></div>
          <div style="position:absolute;top:7px;left:9px;width:16px;height:16px;border-radius:50%;background:#22B573"></div>
        </div>`,
        iconSize: [34, 34],
      });

    const bounds = [];
    locations.forEach((loc) => {
      if (loc.lat && loc.lng) {
        bounds.push([loc.lat, loc.lng]);
        L.marker([loc.lat, loc.lng], { icon: pin(loc.type) })
          .addTo(map)
          .bindPopup(
            `<strong>${loc.type}</strong><br/>${loc.address}<br/>${loc.city}`
          );
      }
    });
    if (bounds.length) map.fitBounds(bounds, { padding: [50, 50], maxZoom: 9 });

    return () => {
      map.remove();
      mapRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={ref} className="w-full h-[360px] rounded-2xl overflow-hidden shadow-lg z-0" />;
}
